export const billRouter = [
  {
    path: '/bill',
    name: 'bill',
    component: () => import('@/views/bill'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/bill/subscribeSet',
    name: 'subscribeSet',
    component: () => import('@/views/bill/subscribeSet'),
    meta: {
      title: '营收报表订阅设置'
    }
  },
  {
    path: '/bill/statementSet',
    name: 'statementSet',
    component: () => import('@/views/bill/statementSet'),
    meta: {
      title: '接受报表设置'
    }
  },
  {
    path: '/bill/bankSubsidyInfo',
    name: 'bankSubsidyInfo',
    component: () => import('@/views/bill/bankSubsidyInfo'),
    meta: {
      title: '银行补贴明细'
    }
  },
  {
    path: '/bill/bankSubsidyHelp',
    name: 'bankSubsidyHelp',
    component: () => import('@/views/bill/bankSubsidyHelp'),
    meta: {
      title: '帮助'
    }
  },
  {
    path: '/bill/storeRank',
    name: 'storeRank',
    component: () => import('@/views/bill/storeRankDetail'),
    meta: {
      title: '门店对比',
      keepAlive: true
    }
  },
  {
    path: '/bill/selectStore',
    name: 'selectStore',
    component: () => import('@/views/bill/selectStore'),
    meta: {
      title: '选择门店',
      keepAlive: true
    }
  },
  {
    path: '/bill/consumeRecord',
    name: 'billConsumeRecord',
    component: () => import('@/views/bill/consumeRecord'),
    meta: {
      title: '消费记录',
      keepAlive: true
    }
  },
  {
    path: '/bill/customerInfo',
    name: 'billCustomerInfo',
    component: () => import('@/views/bill/customerInfo'),
    meta: {
      title: '顾客信息'
    }
  }
]
